import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Appointment } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';
import { getAppointmentTitle } from '../PatientSingleSessionItem';
import { usePatientMatchedProvider } from '@uplift/queries';
import { InCallUpcomingAppointmentSingleItem } from './items/InCallUpcomingAppointmentSingleItem.component';


export const InCallCareTeamUpcomingAppointment: React.VFC<{ appointment: Appointment }> = ({ appointment }) => {
  const { data: provider } = usePatientMatchedProvider(appointment.patientId, appointment.providerId, [ 'active' ]);

  const subtitle = React.useMemo(() => {
    if (!provider) {
      return '';
    }

    const duration = CalendarDateService.date(appointment.toDatetime).diff(appointment.fromDatetime, 'minutes');
    const appointmentTitle = provider.user.medicalRole && getAppointmentTitle(provider.user.medicalRole, duration);

    return `${appointmentTitle} with ${provider.overview.displayName}`;
  }, [ provider, appointment ]);

  return (
    <InCallUpcomingAppointmentSingleItem
      appointment={appointment}
      subtitle={subtitle}
    />
  );
};


const useStyles = makeStyles({ name: 'InCallUpcomingAppointmentsWithCareTeam' })(theme => ({
  root: {
    padding: theme.spacing(3),
  },
  title: {
    fontSize: '18px',
    paddingBottom: theme.spacing(1),
  },
}));


export type InCallUpcomingAppointmentsWithCareTeamProps = {
  patientId: string;
  appointments: Appointment[];
};


export const InCallUpcomingAppointmentsWithCareTeam: React.VFC<InCallUpcomingAppointmentsWithCareTeamProps> = (props) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Next session with care team</Typography>
      <Box>
        {props.appointments.map(appointment => (
          <InCallCareTeamUpcomingAppointment
            key={appointment.id}
            appointment={appointment}
          />
        ))}
      </Box>
    </Box>
  );
};
